export { A11yWizardEntryPoint } from './a11yWizardAdapterEntryPoint';
